import React from 'react'
import { Viewer, Worker } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import PropTypes from 'prop-types'
import { saveError } from 'shared/sentry'

import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

export const PdfDisplay = ({ url }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin()

  const renderError = () => {
    saveError({ message: "Failed to render PDF" })
    return (
      <div style={{ color: 'red' }}>
        <p>An error occurred while loading the PDF</p>
      </div>
    )
  }

  const getWorkerUrl = () => {
    const baseUrl = window.location.origin
    return `${baseUrl}/js/pdf.worker.min.js`
  }

  return (
    <div style={{ height: '500px' }}>
      <Worker workerUrl={getWorkerUrl()}>
        <Viewer
          fileUrl={url}
          plugins={[defaultLayoutPluginInstance]}
          renderError={renderError}
          renderMode="canvas"
        />
      </Worker>
    </div>
  )
}

PdfDisplay.propTypes = {
  url: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Uint8Array)
  ])
}
